const API_URL = import.meta.env.DEV 
  ? 'http://localhost:4100'
  : 'https://greenbalance.poropo.es';

const API_BASE_URL = `${API_URL}/api`;

export const api = {
  async analyzeImage(imageUrl: string, imageId: number | string, threadId: string | null) {
    const response = await fetch(`${API_URL}/assist`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ imageUrl, imageId, threadId }),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || 'Error al analizar la imagen');
    }
    
    return response.json();
  },

  async uploadImage(file: File) {
    const formData = new FormData();
    formData.append('image', file);
    
    const response = await fetch(`${API_BASE_URL}/upload-image`, {
      method: 'POST',
      body: formData,
    });
    
    if (!response.ok) {
      throw new Error('Error al subir la imagen');
    }
    
    return response.json();
  },

  async getHistory() {
    const response = await fetch(`${API_BASE_URL}/history`);
    if (!response.ok) {
      throw new Error('Error al obtener el historial');
    }
    return response.json();
  },

  async register(userData: {
    fullName: string;
    email: string;
    password: string;
    country?: string;
    weeklyGoal?: number;
    excludedVegetables?: string[];
    iaConsent?: boolean;
  }) {
    const response = await fetch(`${API_BASE_URL}/register`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(userData),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || 'Error al registrar usuario');
    }

    return response.json();
  },

  async updateProfile(profileData: {
    id: string;
    fullName: string;
    country?: string;
    weeklyGoal?: number;
    excludedVegetables?: string[];
    iaConsent?: boolean;
  }) {
    const response = await fetch(`${API_BASE_URL}/profile`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(profileData),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || 'Error al actualizar perfil');
    }

    return response.json();
  },

  async ping() {
    const response = await fetch(`${API_BASE_URL}/ping`);
    if (!response.ok) {
      throw new Error('Error al conectar con el servidor');
    }
    return response.json();
  },

  // Métodos genéricos para GET y POST
  async get(endpoint: string, options?: RequestInit) {
    const response = await fetch(`${API_BASE_URL}${endpoint}`, options);
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || 'Error en la petición GET');
    }
    return response.json();
  },

  async post(endpoint: string, data: any) {
    const response = await fetch(`${API_BASE_URL}${endpoint}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || 'Error en la petición POST');
    }

    return response.json();
  },

  async validatePlate(imageUrl: string, ingredientes: string[]) {
    const response = await fetch(`${API_BASE_URL}/validate-plate`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ imageUrl, ingredientes }),
    });
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || 'Error al validar el plato');
    }
    return response.json();
  },
}; 